<script>
import { processRefund } from '@/api/billing.js';

export default {
    data() {
        return {
            notes: '',
        };
    },
    computed: {
        isShow() {
            return this.$store.getters.IS_SHOW_REFUND_REVIEW;
        },
        refund() {
            return this.$store.getters.REFUND_REVIEW_DATA;
        },
    },
    methods: {
        close() {
            this.$store.commit('IS_SHOW_REFUND_REVIEW', false);
            this.notes = '';
        },
        async approve() {
            this.$store.commit('SHOP_POPUP_NAME', 'confirmed');
            this.$store.commit(
                'CONFIRMED_POPUP_METHOD',
                this.confirmApprove.bind(this)
            );
        },
        async reject() {
            this.$store.commit('SHOP_POPUP_NAME', 'confirmed');
            this.$store.commit(
                'CONFIRMED_POPUP_METHOD',
                this.confirmReject.bind(this)
            );
        },
        async confirmApprove() {
            const success = await processRefund(
                this.refund.id,
                true,
                this.notes || null
            );

            // Early return on failure
            if (!success) {
                return;
            }

            this.$store.commit('POPUP_ADD', {
                title: 'REFUND APPROVED',
                description: [
                    'Refund has been approved and queued for processing',
                ],
                color: '#00d25b',
            });
            this.close();
            await this.$store.dispatch('loadRefunds');
        },
        async confirmReject() {
            const success = await processRefund(
                this.refund.id,
                false,
                this.notes || null
            );

            // Early return on failure
            if (!success) {
                return;
            }

            this.$store.commit('POPUP_ADD', {
                title: 'REFUND REJECTED',
                description: ['Refund request has been rejected'],
                color: '#ff9800',
            });
            this.close();
            await this.$store.dispatch('loadRefunds');
        },
    },
};
</script>

<template>
    <div v-if="isShow && refund" class="popup_background">
        <div class="left_additional_container">
            <div class="left_sub_panel_header">
                <label>Review Refund Request #{{ refund.id }}</label>
                <button class="button_blue_100" @click="close">Close</button>
            </div>
            <hr class="hr_light_98" />

            <div class="left_sub_panel_data">
                <div class="info_section">
                    <h3>User Information</h3>
                    <p><strong>User ID:</strong> #{{ refund.user_id }}</p>
                </div>

                <div class="info_section">
                    <h3>Payment Details</h3>
                    <p><strong>Payment ID:</strong> #{{ refund.payment_id }}</p>
                    <p>
                        <strong>Amount:</strong> {{ refund.currency }}
                        {{ refund.amount }}
                    </p>
                </div>

                <div class="info_section">
                    <h3>Refund Request</h3>
                    <p>
                        <strong>Requested:</strong>
                        {{ new Date(refund.created_at).toLocaleString() }}
                    </p>
                    <p><strong>Reason:</strong></p>
                    <div class="reason_box">{{ refund.reason }}</div>
                </div>

                <div class="admin_section">
                    <h3>Admin Decision</h3>
                    <label class="mb_5">Notes (optional):</label>
                    <textarea
                        v-model="notes"
                        rows="4"
                        placeholder="Add internal notes or reasoning..."
                    ></textarea>
                </div>

                <div class="actions_section">
                    <button class="button_blue_100" @click="approve">
                        Approve Refund
                    </button>
                    <button class="button_blue_100 button_red" @click="reject">
                        Reject Request
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.info_section {
    margin-bottom: 20px;
    padding: 15px;
    background: var(--background-hover);
    border-radius: 8px;
}

.info_section h3 {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: var(--text-color);
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 8px;
}

.info_section p {
    margin: 5px 0;
    color: var(--text-color-primary);
}

.reason_box {
    margin-top: 5px;
    padding: 12px;
    background: var(--background);
    border-left: 3px solid var(--main-color);
    border-radius: 4px;
    color: var(--text-color-primary);
}

.admin_section {
    margin: 20px 0;
}

.admin_section h3 {
    margin: 0 0 15px 0;
    font-size: 16px;
    color: var(--text-color);
}

.actions_section {
    display: flex;
    gap: 12px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid var(--border-color);
}

.actions_section button {
    flex: 1;
    padding: 12px 24px;
    font-size: 16px;
}
</style>
